<ng-template #staticDataModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title mt-0" title="{{payload.item.nome}}">Editar: {{payload.item.nome | slice:0:28}}...</h5>
        <button type="button" class="btn-close" (click)="modal.dismiss('Cross click')" aria-hidden="true"></button>
    </div>
    <form [formGroup]="editarForm" (ngSubmit)="confirm()">
        <input hidden formControlName="id">
        <input hidden formControlName="grupoId">
        <div class="modal-body">

            <div class="row">
                <!-- Name and Email -->
                <div class="col-12 col-md-12 mb-3">
                    <div class="form-group">
                        <label class="form-label" for="nome">Nome<span style="color: red;"> *</span> </label>
                        <input type="text" class="form-control-sm form-control" placeholder="nome produto" formControlName="nome" [ngClass]="{
                            'is-invalid':
                            editarForm.controls.nome.errors &&
                            editarForm.get('nome')?.touched,
                          }" />
                        <div class="invalid-feedback"
                            *ngIf="editarForm.get('nome')?.touched && editarForm.get('nome')?.invalid">
                            O nome é obrigatório.
                        </div>
                    </div>
                </div>
                <!-- Quando tipoDeCalculo === 3, os três inputs ficam na mesma linha -->
                <ng-container *ngIf="isTipoCalculo3">
                    <div class="col-12 col-md-4 mb-3">
                        <div class="form-group">
                            <label class="form-label" for="valor">Valor<span style="color: red;"> *</span></label>
                            <input placeholder="0,00" 
                                currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                                type="text" class="form-control-sm form-control" formControlName="valor" [ngClass]="{
                                    'is-invalid':
                                    editarForm.controls.valor.errors &&
                                    editarForm.get('valor')?.touched,
                                  }" />

                            <div class="invalid-feedback"
                                *ngIf="editarForm.get('valor')?.touched && editarForm.get('valor')?.invalid">
                                O vaor é obrigatório.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <div class="form-group">
                            <label class="form-label" for="metroQuadrado">M²</label>
                            <input type="text" 
                                class="form-control form-control-sm" 
                                placeholder="0,00"
                                formControlName="metroQuadrado"
                                mask="separator.2" 
                                thousandSeparator="." 
                                decimalMarker=","
                                [dropSpecialCharacters]="false" />
                        </div>
                    </div>
                    <div class="col-12 col-md-4 mb-3">
                        <div class="form-group">
                            <label class="form-label" for="metroQuadradoAdicional">M² Adicional</label>
                            <input type="text" 
                                class="form-control form-control-sm" 
                                placeholder="0,00"
                                formControlName="metroQuadradoAdicional"
                                mask="separator.2" 
                                thousandSeparator="." 
                                decimalMarker=","
                                [dropSpecialCharacters]="false" />
                        </div>
                    </div>
                </ng-container>

                <!-- Quando tipoDeCalculo !== 3, apenas o input de valor -->
                <ng-container *ngIf="!isTipoCalculo3">
                    <div class="col-12 col-md-5 mb-3">
                        <div class="form-group">
                            <label class="form-label" for="valor">Valor<span style="color: red;"> *</span></label>
                            <input placeholder="0,00" 
                                currencyMask
                                [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }"
                                type="text" class="form-control-sm form-control" formControlName="valor" [ngClass]="{
                                    'is-invalid':
                                    editarForm.controls.valor.errors &&
                                    editarForm.get('valor')?.touched,
                                  }" />

                            <div class="invalid-feedback"
                                *ngIf="editarForm.get('valor')?.touched && editarForm.get('valor')?.invalid">
                                O vaor é obrigatório.
                            </div>
                        </div>
                    </div>
                </ng-container>

            </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-light" (click)="modal.close('Close click')">Cancelar</button>
            <button [disabled]="editarForm.invalid" type="submit" class="btn btn-success">Salvar</button>
        </div>
    </form>
</ng-template>